<template>
  <v-main>
    <router-view @showSnackbar="onShowSnackbar" />
    <Snackbar 
      :show="snackbar.show"
      :text="snackbar.text"
      :button="snackbar.button"
      :routeTo="snackbar.routeTo"
      @onClose="snackbar.show=false"
    />
    <div style="margin:150px 0;">&nbsp;</div>
  </v-main>
</template>

<script>
  import Snackbar from '@/components/Snackbar';
  export default {
    name: 'DashboardCoreView',
    components: {
      Snackbar,
    },
    data: () => ({
      snackbar: {
        show: false,
        text: '',
        button: '',
        routeTo: '',
      }
    }),
    methods: {
      onShowSnackbar (payload) {
         this.snackbar.text = payload.text;
         this.snackbar.button = payload.button ? payload.button : 'OK';
         this.snackbar.routeTo = payload.routeTo ? payload.routeTo : '';
         this.snackbar.show = true;
      }
    }
  }
</script>
